import type { DefaultComponent } from "@loadable/component";
import pMinDelay from "p-min-delay";

import { withTimeout } from "../../helpers";

// this is recommended to avoid a loading flash in case the bundle loads instantly
// https://loadable-components.com/docs/delay/
export const minLoaderDelayInMilliseconds = 200;
export const loaderTimeoutInMilliseconds = 15 * 1000;

export const withDefaultLoaderModifiers = <T>(internalImport: Promise<DefaultComponent<T>>) =>
  withTimeout(loaderTimeoutInMilliseconds, pMinDelay(internalImport, minLoaderDelayInMilliseconds));
